import React, { useState } from 'react';
import AttendanceCalendar from './AttendanceCalendar';
import StudentAttendanceSummary from './StudentAttendanceSummary';

function StudentAttendanceView({ userClass, userId }) {
  const [currentDate, setCurrentDate] = useState(new Date());

  return (
    <>
      <div className="professional-card" style={{ gridColumn: 'span 2', background: 'transparent', border: 'none', boxShadow: 'none' }}>
        <AttendanceCalendar 
          userClass={userClass} 
          userRole="student" 
          students={[]} 
          currentDate={currentDate}
          onDateChange={setCurrentDate}
          userId={userId}
        />
      </div>

      <div className="professional-card" style={{ gridColumn: 'span 2', background: 'transparent', border: 'none', boxShadow: 'none' }}>
        <StudentAttendanceSummary 
          userClass={userClass} 
          userId={userId} 
          currentDate={currentDate}
        />
      </div>
    </>
  );
}

export default StudentAttendanceView;